<template>
  <div>
    <div class="modal-backdrop fade"></div>
    <div aria-hidden="true" class="onboarding-modal modal fade animated show" id="onboardingWideFormModal" role="dialog" tabindex="-1" style="display: block;">
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">

            <h5 class="modal-title" id="exampleModalLabel">Copy Preview</h5>
            <button aria-label="Close" class="close" @click="closeModal" type="button">
              <span aria-hidden="true"> ×</span>
            </button>
          </div>

          <div class="modal-body" >
            <button v-if="latestRevision > 0" @click="copyProduct">Copy This Product</button>
            <ProductCopy v-if="latestRevision > 0" :product="selectedProduct" :revision="latestRevision" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Product from '@/mixins/product'
import ProductCopy from '@/components/copydesk/ProductCopy'

export default {
  props: ['settings'],
  mixins: [Product],
  components: {
    ProductCopy
  },
  data () {
    return {
      selectedProduct: '',

      productCopy: '',
      productRevisions: '',

      loading: true,
      loadingProduct: false
    }
  },
  mounted () {
    this.selectedProduct = this.settings.content
    if (this.selectedProduct && this.selectedProduct.id_product) {
      this.getProductCopyDuplicate()
    }
  },
  methods: {
    closeModal () {
      var context = {
        content: 'image',
        contentType: '',
        show: false
      }
      this.$store.dispatch('updateModal', context)
    },
    copyProduct () {
      var productCopy = this.productCopy.map(copy_header => {
        if (copy_header.is_allow_copy_value == 0) {
          copy_header.value = ''
          copy_header.value_dropdown = ''
        }
        return copy_header
      })
      var ctx = {
        'selectedProductCopy': productCopy
      }
      this.$store.dispatch('updateduplicateProductCopy', ctx)
      this.closeModal()
    }
  },
  computed: {
    latestRevision () {
      if (this.productRevisions) { return this.productRevisions[this.productRevisions.length - 1].id_copy_revision }
    }
  }
}
</script>

<style scoped>
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.2/animate.min.css";
</style>
